import { Globe, LineChart, Users, Handshake } from 'lucide-react';

export const features = [
  {
    icon: Handshake,
    title: 'Exclusive Membership',
    text: 'A curated global community of people who move, play, and connect — wherever they are.'
  },
  {
    icon: Globe,
    title: 'Global Network',
    text: 'Join and create clubs, meet others, and stay active through sport and wellness in any city.'
  },
  {
    icon: LineChart,
    title: 'Performance Tracking',
    text: 'Track your progress with AI-powered insights to improve how you play and train.'
  },
  {
    icon: Users,
    title: 'Personalized Experience',
    text: 'Get matched with trainers and members based on your location, goals, and favorite activities.'
  }
];
